<template>
  <div>
    <el-form :inline="true" :model="filterModel" class="demo-form-inline">
      <el-form-item label="订单号">
        <el-input
          style="width: 220px"
          size="mini"
          v-model="filterModel.orderNumber"
          placeholder="订单号"
          :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="备案号">
        <el-input
          style="width: 220px"
          size="mini"
          v-model="filterModel.preservationId"
          placeholder="备案号"
          :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="filterSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      class="data-list"
      style="border: 1px solid #eeeeee; border-bottom: 0; width: 100%"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '600',
      }"
    >
      <template>
        <el-table-column
          label="订单号"
          prop="orderNumber"
          show-overflow-tooltip
          min-width="188"
        >
        </el-table-column>
        <el-table-column label="备案号" prop="preservationId" min-width="186">
          <template slot-scope="scope"
            >{{ scope.row.preservationId | leftPadZero(10) }}
          </template>
        </el-table-column>

        <el-table-column
          label="受理机关"
          prop="orgName"
          min-width="186"
        ></el-table-column>
        <el-table-column label="创建日期" prop="applyTime" min-width="186">
          <template slot-scope="scope"
            >{{ scope.row.applyTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column
          label="订单状态"
          prop="statusStr"
          min-width="186"
        ></el-table-column>

        <el-table-column label="操作" min-width="186">
          <template slot-scope="scope">
            <span
              v-if="scope.row.status === 1"
              class="color-success pointer"
              @click="gotoTestifyOnLoginStatus(scope.row)"
              >立即支付</span
            >
            <span
              v-if="scope.row.status === 5"
              class="color-success pointer"
              @click="showFileReason(scope.row)"
              >查看原因</span
            >
            <span
              v-if="scope.row.status === 4"
              class="color-success pointer"
              @click="downTestifyPrePkg(scope.row)"
              >下载证书</span
            >
          </template>
        </el-table-column>
      </template>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <el-row class="pageation">
      <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="filterModel.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="filterModel.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="filterModel.pageTotal"
        />
        <el-go
          :page-size="filterModel.pageSize"
          :total="filterModel.pageTotal"
          @current-change="handleCurrentChange"
          style="margin-right: 5px"
        ></el-go>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "@/components/go/Go";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  name: "safeguard-table",
  data () {
    return {
      currentCode: "",
      filterModel: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        orderNumber: "",
        preservationId: "",
      },

      tableData: [],
    };
  },
  components: { ElGo },
  props: {
    currentName: String,
  },

  created () {
    this.filterSearch();
  },
  methods: {
    // 搜索按钮
    filterSearch () {
      this.filterModel.itemPage = 1;
      this.queryGzzs();
    },

    // 查询公证证书
    queryGzzs () {
      let param = Object.assign({}, this.filterModel);
      ApiCorpMethods.SafeguardController.queryNotarialOrder(param).then((res) => {
        if (!res.success) {
          return this.$message.error(res.description || "查询数据失败");
        }
        this.tableData = res.data;
        this.filterModel.pageTotal = res.total;
        this.filterModel.pageSize = res.pageSize;
      });
    },

    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryGzzs();

    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryGzzs();
    },

    gotoTestifyOnLoginStatus: function (item) {
      var _this = this;
      var param = { preservationId: item.preservationId, certCode: item.certCode, orgCode: item.orgCode };
      let newWindow;
      if (!isInDingTalk) newWindow = window.open("", "_blank");
      ApiCorpMethods.SafeguardController.redirectTesity(param).then(
        (result) => {
          if (!result.success) {
            if (!isInDingTalk) newWindow.close();
            return _this.$message.error(result.description || "操作失败");
          }
          isInDingTalk ? location.href = result.data : newWindow.location.href = result.data;
        }
      );
    },
    showFileReason: function (item) {
      this.$alert(item.faildDesc, "失败原因", {
        confirmButtonText: "确定",
        callback: (action) => {
        },
      });
    },

    downTestifyPrePkg: function (item) {
      var _this = this,
        param = { orderNumber: item.orderNumber };
      ApiCorpMethods.SafeguardController.notarialLink(param).then((result) => {
        if (!result.success) {
          return _this.$message.error(result.description || "操作失败");
        }
        /*result.data.fix = ".zip";
        ApiMethods.FileOperController.download_down(result.data);*/
        location.href = result.data
      });
    },
  },
};
</script>

<style type="less" scoped>
.color-success {
  color: #290202;
  font-weight: bold;
  cursor: pointer;
}

.color-success:hover {
  color: #ec1c1c;
}
</style>



// WEBPACK FOOTER //
// components/order/safeguardTable.vue